import React from 'react';
import { HamburgerButtonContainerProps, HamburgerButtonContainer, HamburgerButtonLine } from './HamburgerButton.styles';

interface HamburgerButtonProps extends HamburgerButtonContainerProps {
  handleClick: () => void;
}

const HamburgerButton = ({ handleClick, isActive }: HamburgerButtonProps): JSX.Element => {
  return (
    <HamburgerButtonContainer
      onClick={handleClick}
      className='hamburger-button'
      isActive={isActive}
    >
      <HamburgerButtonLine className='top-line' />
      <HamburgerButtonLine className='center-line' />
      <HamburgerButtonLine className='bottom-line' />
    </HamburgerButtonContainer>
  );
};

export default HamburgerButton;
